import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NotificationComponent } from '../admin/notification/notification.component';
// not supported anymore
// import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminComponent implements OnInit {


  constructor(
    private dialog: MatDialog, public dialogRef: MatDialogRef<NotificationComponent>
  ) { }

  ngOnInit(): void {
  }

  LoadNotification(elementId: string) {
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,
      // data: {
      //   selectedoffering: elementId,
      // }
    }
    // replacing old modal mdbootstrap with compatible angular material modal
    // this.modalRef = this.modalService.show(NotificationComponent, modalOptions)
    this.dialogRef = this.dialog.open(NotificationComponent, {
      width: '500px',
      data: modalOptions
    });
  }


}
